import { createStoreSelector } from "../selectors";
export const selectConfig = (state) => createStoreSelector(state, 'config')(state);
//# sourceMappingURL=config.selectors.js.map